import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './Loader';

const mapStyles = {
  map: {
    position: 'absolute',
    width: '100%',
    height: '100%'
  }
};

export class CurrentLocation extends React.Component {

    constructor(props) {
        super(props);
    
        const { lat, lng } = this.props.initialCenter;
        this.state = {
            currentLocation: {
                lat: lat,
                lng: lng,
            },
            address: ''
        };
    }

    recenterMap() {
        const map = this.map;
        const current = this.state.currentLocation;
    
        const requestOption = {
          method: 'GET'
        };

        fetch('https://maps.googleapis.com/maps/api/geocode/json?address='+current.lat+','+current.lng+'&key=AIzaSyCTkUK9u3gNBcNnw4PDgbIfXCYDiixfd7U', requestOption)
        .then(res => res.json())
        .then(response => {
          let address = response.results[0].formatted_address;
          //console.log('Inside Recenter');
          //console.log(address);
          this.setState({ address: address });
          this.handleGetAddress3();
        })
        .catch(error => {
            console.warn(error);
        });

        const google = this.props.google;
        const maps = google.maps;
    
        if (map)
        {
            let center = new maps.LatLng(current.lat, current.lng);
            map.panTo(center);
        }
    }

    loadMap()
    {
        if (this.props && this.props.google) {
          // checks if google is available
          const { google } = this.props;
          const maps = google.maps;
    
          const mapRef = this.refs.map;
    
          // reference to the actual DOM element
          const node = ReactDOM.findDOMNode(mapRef);
    
          let { zoom } = this.props;
          const { lat, lng } = this.state.currentLocation;
          const center = new maps.LatLng(lat, lng);
          const mapConfig = Object.assign(
            {},
            {
              center: center,
              zoom: zoom
            }
          );
    
          // maps.Map() is constructor that instantiates the map
          this.map = new maps.Map(node, mapConfig);
        }
    }

    handleGetAddress3 = () =>{

        const { lat, lng } = this.state.currentLocation;
        this.props.handleGetAddress2(lat,lng);  
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.google !== this.props.google) {
          //console.log('loadmap');
          this.loadMap();
        }
        if (prevState.currentLocation !== this.state.currentLocation) {
          //console.log('recentermap');
          this.recenterMap();
        }
      }

    componentDidMount() 
    {
      //console.log('mounted');
        this.loadMap();
        this.handleGetAddress3();
    }

    renderChildren() {
        const { children } = this.props;
    
        if (!children) return;

        //console.log(this.state.currentLocation);

        return React.Children.map(children, c => {
          if (!c) return;
          return React.cloneElement(c, {
            map: this.map,
            google: this.props.google,
            mapCenter: this.state.currentLocation
          });
        });
    }
    
    render() {
        const style = Object.assign({}, mapStyles.map);
        return (
            <div>
                <div style={{width: '100%', height: '300px', 'overFlow': 'hidden'}} ref="map"> {/*style={style} */}
                  <Loader />
                </div>
                {this.renderChildren()}
            </div>
       );
    }

}


export default CurrentLocation;

CurrentLocation.defaultProps = {
  zoom: 14,
  initialCenter: {
    lat: 15.470236, 
    lng: 73.8254184,
  },
  centerAroundCurrentLocation: false,
  visible: true
};


// WEBPACK FOOTER //
// ./src/components/UpdateMap.js